import './FrameContainer.css'

import type { ReactNode } from 'react'

interface FrameContainerProps {
  children: ReactNode
  backgroundColor?: string
  resOverride?: { height: number; width: number }
}

const FrameContainer = ({ children, backgroundColor = 'transparent', resOverride }: FrameContainerProps) => {
  return (
    <div
      className="frame-container"
      style={{
        width: resOverride ? `${resOverride.width}px` : '100vw',
        height: resOverride ? `${resOverride.height}px` : '100vh',
        backgroundColor,
      }}
    >
      {children}
    </div>
  )
}

export default FrameContainer
